import { Breadcrumb, Page, useEntity } from 'components';
import { ReactElement } from 'react';
import invariant from 'tiny-invariant';
import type { CampaignDetails } from 'modules/campaign/campaign/types';
import { ObjectTaskList } from 'modules/tasks/ObjectTaskList/ObjectTaskList';

export function Tasks(): ReactElement {
  const { item, mutate } = useEntity<CampaignDetails>();

  return (
    <Page narrow>
      <Breadcrumb>Tasks</Breadcrumb>
      <ObjectTaskList
        taskList={item.task_list}
        onTaskListUpdate={(task_list) => {
          mutate((campaign) => {
            invariant(campaign);
            return { ...campaign, task_list };
          });
        }}
      />
    </Page>
  );
}
